import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
import { defineMessages } from '@/lib/i18n';
import { i18n } from '@/plugins/vue-i18n';
import sharedMessages from '@/lib/shared-messages';
import { useChemicanUrls } from '@/composables/useChemicanUrls';
import BaseButtonSubmit from '@/views/base/BaseButtonSubmit.vue';
import BaseButtonText from '@/views/base/BaseButtonText.vue';
import BaseFormCard from '@/views/base/BaseFormCard.vue';
import VerifyForm from '@/views/pages/login/VerifyForm.vue';
import { useVerification } from '@/composables/useVerification';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginVerifyPageComponent',
  setup(__props) {

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  verify: '認証',
  // Shown instead of "二要素認証" for the email code challenge: users who never
  // set up 2FA also see this screen (device verification), so naming a feature
  // they didn't enable would look like phishing.
  identityVerification: '本人確認',
  needSupport: 'サポートが必要ですか？',
  contactSupportSms:
    'アカウントの確認がうまくいかない場合や、SMSコードが届かない場合は、',
  contactSupportPlain: 'アカウントにサインインできない場合は、',
  supportLink: 'サポートに連絡してください。',
});

const isValidForm = ref<boolean>(false);

// 共通の URL 生成ロジックを使用
const { contactUrl } = useChemicanUrls();

// Use the verification composable
const {
  mode,
  verificationToken,
  isInitializing,
  isVerifying,
  errorAlert,
  waitForCooldown,
  resendingCode,
  resendRequired,
  codeResent,
  cooldownTimeLeft,
  tfaPhoneNumber,
  tfaEmail,
  emailAuthEnabled,
  showAlternatives,
  canUseBackupCodes,
  verifyCode,
  resendCode,
  updateVerificationToken,
  initializeVerification,
  switchMode,
} = useVerification({
  isDialog: false,
});

// Initialize on mount
onMounted(async () => {
  await initializeVerification();
});

return { __sfc: true,$t, m, isValidForm, contactUrl, mode, verificationToken, isInitializing, isVerifying, errorAlert, waitForCooldown, resendingCode, resendRequired, codeResent, cooldownTimeLeft, tfaPhoneNumber, tfaEmail, emailAuthEnabled, showAlternatives, canUseBackupCodes, verifyCode, resendCode, updateVerificationToken, initializeVerification, switchMode, sharedMessages, BaseButtonSubmit, BaseButtonText, BaseFormCard, VerifyForm }
}

})